/**
 * Updates contact menu Live Chat subtext from Gorgias availability when loaded.
 */

/**
 * @param {string | undefined | null} value
 * @returns {string}
 */
function normalizeText(value) {
  return typeof value === 'string' ? value.trim() : '';
}

/**
 * @returns {{ online: string, afterHours: string, click: string }}
 */
function readStatusLabels() {
  const body = document.body;
  return {
    online: normalizeText(body.dataset.contactChatOnline),
    afterHours: normalizeText(body.dataset.contactChatAfterHours),
    click: normalizeText(body.dataset.contactChatClick) || 'Click to chat',
  };
}

/**
 * @param {string} text
 */
function setChatSubtext(text) {
  if (!text) return;
  document.querySelectorAll('[data-contact-chat-sub]').forEach((element) => {
    element.textContent = text;
  });
}

/**
 * @returns {string}
 */
function resolveStatusLabel() {
  const labels = readStatusLabels();
  const gorgias = /** @type {any} */ (window).GorgiasChat;

  if (!gorgias) return labels.click;

  try {
    if (typeof gorgias.isChatOnline === 'function' && gorgias.isChatOnline()) {
      return labels.online || labels.click;
    }

    if (typeof gorgias.isBusinessHours === 'function' && !gorgias.isBusinessHours()) {
      return labels.afterHours || labels.click;
    }
  } catch {
    return labels.click;
  }

  return labels.click;
}

function openContactCardChat() {
  const gorgias = /** @type {any} */ (window).GorgiasChat;
  if (gorgias && typeof gorgias.open === 'function') {
    gorgias.open();
    return;
  }

  const initPromise = /** @type {Promise<void> | undefined} */ (window).initGorgiasChatPromise;
  if (initPromise && typeof initPromise.then === 'function') {
    initPromise.then(() => {
      const readyGorgias = /** @type {any} */ (window).GorgiasChat;
      if (readyGorgias && typeof readyGorgias.open === 'function') {
        readyGorgias.open();
      }
    }).catch(() => {});
    return;
  }

  const launcher = document.querySelector(
    '#gorgias-chat-container, [data-gorgias-widget-id], iframe[name*="gorgias"], .gorgias-chat-key-1gq4km'
  );
  if (launcher instanceof HTMLElement) {
    launcher.dispatchEvent(new MouseEvent('click', { bubbles: true }));
  }
}

/**
 * @param {MouseEvent} event
 */
function handleContactCardChatClick(event) {
  const target = event.target;
  if (!(target instanceof Element) || !target.closest('[data-contact-card-chat]')) return;
  event.preventDefault();
  openContactCardChat();
}

function initContactChatStatus() {
  const labels = readStatusLabels();
  setChatSubtext(labels.click);
  document.addEventListener('click', handleContactCardChatClick);

  const initPromise = /** @type {Promise<void> | undefined} */ (window).initGorgiasChatPromise;
  if (!initPromise || typeof initPromise.then !== 'function') return;

  initPromise
    .then(() => {
      setChatSubtext(resolveStatusLabel());
    })
    .catch(() => {
      setChatSubtext(labels.click);
    });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initContactChatStatus, { once: true });
} else {
  initContactChatStatus();
}
